import { useCallback, useContext } from 'react'
import { PatientDetailContext } from './patientDetailContext'

export const usePatientDetail = () => {
  const { onboardingState, enrolledPrograms, id, setState, refetch } =
    useContext(PatientDetailContext)

  const patientIsInProgram = (programUid: string) => !!enrolledPrograms?.includes(programUid)

  const switchPatient = useCallback(
    (id: string) => {
      setState(state => ({ ...state, id: id }))
    },
    [setState],
  )

  return {
    patientIsInProgram,
    switchPatient,
    id,
    onboardingState,
    enrolledPrograms,
    refetch,
  }
}
